import { render } from "./BaseMultiselect_new.vue?vue&type=template&id=031c698f&scoped=true"
import script from "./BaseMultiselect_new.vue?vue&type=script&lang=js"
export * from "./BaseMultiselect_new.vue?vue&type=script&lang=js"

import "./BaseMultiselect_new.vue?vue&type=style&index=0&id=031c698f&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031c698f"]])

export default __exports__